import { render, staticRenderFns } from "./Certification.vue?vue&type=template&id=68fefe3a&"
import script from "./Certification.vue?vue&type=script&lang=ts&"
export * from "./Certification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports